/** AI allowance views. The learner sees their own "% left"; tenant-admins
 *  and super-admins get roster / per-tenant breakdowns. */
import { request } from "./http";

export interface MyAiUsage {
  /** Whether this account has been paid for. Decides WHICH allowance
   *  applies — and whether it ever comes back. */
  subscribed: boolean;
  /** "monthly" resets on the 1st; "taster" is one conversation, ever. */
  kind: "monthly" | "taster";
  /** All three in PAISE of what the calls cost us. They used to be token
   *  counts; a token cap was a cap a learner could quintuple by choosing
   *  a dearer model, since the same count cost us five times as much. */
  used: number;
  limit: number;
  remaining: number;
  /** The tokens behind that spend. Shown, never capped on. */
  tokens: number;
  /** The same figure as `used`, under its older name. */
  cost_minor: number;
}

export interface LearnerUsage {
  user_id: string;
  full_name: string;
  email: string;
  tokens_this_month: number;
  /** What those tokens cost US, in paise. Tokens are a unit nobody can
   *  act on; rupees answer the question actually being asked. */
  cost_minor: number;
}

export interface TenantUsage {
  tenant_id: string;
  name: string;
  tokens_this_month: number;
  cost_minor: number;
}

/** The founder's one number: what the AI cost this month, against what
 *  learners paid into their wallets over the same period. */
export interface PlatformCost {
  tokens_this_month: number;
  /** Summed from each call's own frozen cost, so a month spent on a
   *  frontier model is not reported at the cheap model's rate. */
  cost_minor: number;
  topped_up_minor: number;
}

export function myAiUsage(): Promise<MyAiUsage> {
  return request("/ai-usage/me");
}

export function tenantLearnerUsage(): Promise<LearnerUsage[]> {
  return request("/ai-usage/learners");
}

export function platformTenantUsage(): Promise<TenantUsage[]> {
  return request("/ai-usage/tenants");
}

export function platformCost(): Promise<PlatformCost> {
  return request("/ai-usage/platform-cost");
}
